import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import vuelidate from './plugins/vuelidate';
import vueDebounce from 'vue-debounce';
import moment from 'moment'
import MagicGrid from 'vue-magic-grid';

Vue.use(MagicGrid);
moment.locale('es');
Vue.prototype.moment = moment;
Vue.use(vueDebounce, {
});

import('@/axios/axios');

Vue.config.productionTip = false;

new Vue({
  vuelidate,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
